export default __webpack_public_path__ + "static/media/Client Images.7d793955.png";